import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { EventsAwardsWinnersPageContext } from "@events-awards/EventsAwardsWinners/utils/types";
import { getAwardType } from "@events-awards/utils/helpers";
import { Route } from "@route-types/Section/layouts/EventsAwards/EventsAwardsWinners/+types/EventsAwardsWinnersPage";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import { fetchEventsAwardsWinnersPageData } from "./EventsAwardsWinnersPage.server";
import EventsAwardsWinnersPageContent from "./EventsAwardsWinnersPageContent";

/** This is the main entry point component for /events-awards route. */
const EventsAwardsWinnersPage = (): React.ReactElement => {
  const context = useLoaderData<EventsAwardsWinnersPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <EventsAwardsWinnersPageContent
      {...context.payload.data}
      gaProps={context.payload.gaProps}
    />
  );
};

export default EventsAwardsWinnersPage;

export const loader = async ({ request }: Route.LoaderArgs) => {
  const url = new URL(request.url, `http://localhost`);
  const path = url.pathname;

  return await fetchEventsAwardsWinnersPageData(getAwardType(path));
};

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as EventsAwardsWinnersPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};
